import { render, staticRenderFns } from "./clientEmployersList.vue?vue&type=template&id=7a796828&scoped=true"
import script from "./clientEmployersList.vue?vue&type=script&lang=js"
export * from "./clientEmployersList.vue?vue&type=script&lang=js"
import style0 from "./clientEmployersList.vue?vue&type=style&index=0&id=7a796828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a796828",
  null
  
)

export default component.exports